// Backend Server Configuration
const config = {
  BACKEND_HOST: process.env.REACT_APP_BACKEND_HOST,
  BACKEND_PORT: process.env.REACT_APP_BACKEND_PORT,
  FIELD_DELIMITER: process.env.REACT_APP_FIELD_DELIMITER,
  SESSION_EXPIRE_MINUTES: parseInt(process.env.REACT_APP_SESSION_EXPIRE_MINUTES),
  SESSION_EXPIRE_WARNING_MINUTES: parseInt(process.env.REACT_APP_SESSION_EXPIRE_WARNING_MINUTES),
  CONTRACT_BASIC_NAME: process.env.REACT_APP_CONTRACT_BASIC_NAME,
  CONTRACT_BASIC_ID: process.env.REACT_APP_CONTRACT_BASIC_ID,

  get BACKEND_URL() {
    // 현재 접속한 도메인을 기준으로 백엔드 URL 생성
    if (typeof window !== 'undefined') {
      const { protocol, hostname, port } = window.location;

      // 프로덕션 HTTPS 도메인(예: https://payroll.doaan.kr): 백엔드는 별도 HTTPS
      // 서브도메인(api.doaan.kr, Cloudflare Tunnel → 집 PC localhost:13500)으로 호출.
      // HTTPS 페이지는 HTTP 백엔드를 부를 수 없으므로 백엔드도 HTTPS여야 함.
      if (protocol === 'https:') {
        return process.env.REACT_APP_API_URL || 'https://api.doaan.kr';
      }

      // 레거시: 프론트(:1350)와 백엔드(:13500)가 포트로 분리된 직접 접속 환경
      // 예: http://doaan.iptime.org:1350 -> http://doaan.iptime.org:13500
      return `${protocol}//${hostname}:${this.BACKEND_PORT || '13500'}`;
    }
    // 서버 사이드 렌더링 환경에서는 환경 변수 사용
    return `http://${this.BACKEND_HOST}:${this.BACKEND_PORT}`;
  }
};

export const SESSION_EXPIRE_MINUTES = config.SESSION_EXPIRE_MINUTES;
export const SESSION_EXPIRE_WARNING_MINUTES = config.SESSION_EXPIRE_WARNING_MINUTES;

export default config;
